module.exports = __webpack_public_path__ + "img/pp_logo-coin.739abb8f.png";